import type { RxJsonSchema } from 'rxdb';
import type { DeficiencyComponentRemoval } from './deficiencyComponentRemoval.types';

export const deficiencyComponentRemovalSchema: RxJsonSchema<DeficiencyComponentRemoval> = {
  type: 'object',
  version: 0,
  description: 'describes component removal',
  primaryKey: 'componentVersionUUId',
  properties: {
    deficiencyId: { type: ['string', 'null'] },
    deficiencyUUID: { type: ['string', 'null'] },
    parentComponentId: { type: ['number', 'null'] },
    componentRemovalId: { type: ['number', 'null'] },
    componentRemovalIdBySC: { type: ['number', 'null'] },
    parentComponentName: { type: ['string', 'null'] },
    commentBySC: { type: ['string', 'null'] },
    comment: { type: ['string', 'null'] },
    assetId: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    siteId: { type: 'number' },
    disciplineId: { type: 'number' },
    dateCreated: { type: ['string', 'null'] },
    inspectionId: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    componentVersionId: { type: ['number', 'null'] },
    componentVersionInspectionId: { type: ['number', 'null'] },
    componentVersionUUId: { type: 'string', maxLength: 36 },
  },
};
